// import { atom } from "recoil";

// export const RoleState = atom({
//   key: "roleState",
//   default: null,
// });

import { atom } from "recoil";

export const RoleState = atom({
  key: "roleState",
  default: null,
});
